import { createContext, useContext } from 'react';
import type { LandingLayout, Surface } from './types';

interface BlockSurfaceValue {
  surface: Surface;
  /** The page's own layout, for cards that keep their look on any background. */
  page: LandingLayout;
}

/** Set only around a block with its own background; null means every block's own surface. */
export const BlockSurfaceContext = createContext<BlockSurfaceValue | null>(null);

/** The surface this block's text sits on: its own, unless a background overrides it. */
export const useSurface = (natural: Surface): Surface =>
  useContext(BlockSurfaceContext)?.surface ?? natural;
